import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppData } from '@shared/models/appdata.model';
import { HardwareVariantOfferingDetails } from '../models/hardware-offering-model';

@Injectable({
  providedIn: 'root',
})
export class HardwareSearchService {
  private http = inject(HttpClient);
  private appData = inject(AppData);

  getHardwareWithGtin(gtin: string, subscriptionIds?: string[]): Observable<HardwareVariantOfferingDetails> {
    const url = `${this.appData.apiUrl}/api/v1/product/hardware/gtin/${gtin}`;
    let params = new HttpParams();
    subscriptionIds?.filter(Boolean).forEach(id => {
      params = params.append('subscriptionIds', id);
    });
    return this.http.get<HardwareVariantOfferingDetails>(url, { params });
  }

  getHardwareNameByGtin(gtin: string): Observable<string> {
    const url = `${this.appData.apiUrl}/api/v1/product/hardware/get-name-by-gtin/${gtin}`;
    return this.http.get<string>(url, { responseType: 'text' as 'json' });
  }

  checkHeadsProductExists(gtin: string): Observable<boolean> {
    const url = `${this.appData.apiUrl}/api/v1/product/heads/${gtin}/exists`;
    return this.http.get<boolean>(url);
  }
}
